module.exports = __webpack_public_path__ + "img/shebao.7dd421df.png";